export const styles = {
  textField: {
    '& input::placeholder': {
      fontStyle: 'italic',
    },
  },
};
